'use strict';

const taxFreeThresholdPassedWarning = {
    createDialog: function () {
        const $taxFreeThresholdBlock = $('.js-tax-warning');
        const $shouldShowModal = $taxFreeThresholdBlock.attr('data-show-threshold-modal');

        if (!$shouldShowModal) {
            return;
        }

        const taxFreeThresholdPrice = $taxFreeThresholdBlock.data('taxFreeThresholdPrice');
        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: String.format(window.Resources.MODAL_TAX_WARNING_HEADING, taxFreeThresholdPrice)
            },
            paragraphs: [{
                text: String.format(window.Resources.MODAL_TAX_WARNING_MESSAGE, taxFreeThresholdPrice)
            }],
            ctaHolder: {},
            buttons: [{
                type: 'btn',
                label: window.Resources.MODAL_TAX_WARNING_OK,
                shouldCloseModal: true
            }],
            closeElement: {
                shouldCloseModal: true
            },
            modalLarge: true,
            centerOnMobile: true,
            customClass: 'threshold-warning'
        });
    }
};

module.exports = taxFreeThresholdPassedWarning;
